import {useDispatch} from "react-redux";
import * as actions from '../../actions/actions'
import {useCallback} from "react";

const useMenuAction = () => {
	const dispatch = useDispatch()
	const setMenu = useCallback((menu) => {
		dispatch(actions.setMenu({menu: menu}))
	}, [dispatch])
	const setMenuItems = useCallback((menuItems) => {
		dispatch(actions.setMenuItems(menuItems))
	}, [dispatch])
	const setMenuActiveItem = useCallback((item) => {
		const itemId = item?.openItem.length > 0 ? item.openItem[0] : null
		dispatch(actions.setMenuActiveItem({openItem: [itemId]}))
	}, [dispatch])
	const setMenuActiveId = useCallback((id) => {
		dispatch(actions.setMenuActiveId(id))
	}, [dispatch])
	const setDrawerOpen = useCallback((drawerOpen) => {
		dispatch(actions.setDrawerOpen(drawerOpen))
	}, [dispatch])
	const setSelectedItems = useCallback((menuSelectedItems) => {
		dispatch(actions.setMenuSelectedItems(menuSelectedItems))
	}, [dispatch])
	const setSelectedLevel = useCallback((menuSelectedLevel) => {
		dispatch(actions.setMenuSelectedLevel(menuSelectedLevel))
	}, [dispatch])
	
	return {
		setMenu,
		setMenuItems,
		setMenuActiveItem,
		setMenuActiveId,
		setDrawerOpen,
		setSelectedItems,
		setSelectedLevel
	}
	
}

export default useMenuAction